export const useShouldShowMyNet = ({
  option,
  isNutrition,
}: {
  option: boolean;
  isNutrition: boolean;
}): boolean => {
  // BEFORE:
  // entityName !== "Grocery" && entityName !== "Meal" && entityName !== "NutritionPlan" &&
  //options?.showMyMfwNet !== false &&
  // (!isWhiteLabel || (isWhiteLabel && organizationId === mfwTheme.theme.orgId)) &&

  const contentPermission = !isNutrition;
  const orgPermission = true;
  const res: boolean = option && contentPermission && orgPermission;
  
  return res;
};
